import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useFetching } from '../hooks/useFetching'
import { AuthContext } from '../context'
import DsuService from '../api/DsuService'
import Loader from '../components/ui/Loader'
import Select from '../components/ui/Select'
import { Link } from 'react-router-dom'

const QuestionTeacher = ({ questions }) => {
  const { studentId } = useContext(AuthContext) 
  const [disciplineAndTeacher, setDisciplineAndTeacher] = useState([])
  const [teachers, setTeachers] = useState([])

  const params = useParams()
  const qNumber = params.number
  const qId = questions.find(q => q.number == qNumber).id

  const [getDisciplineAndTeacherByStudentId, isDisciplineAndTeacherLoading, disciplineAndTeacherErr] = useFetching(async (studentId) => {
    const response = await DsuService.getDisciplineAndTeacherByStudentId(studentId)
    setDisciplineAndTeacher(response.data)
  })

  const [getTeachers, isTeachersLoading, teacherErr] = useFetching(async () => {
    const response = await DsuService.getTeachers()
    const dataArr = []
    response.data.forEach(dataItem => {
        dataArr.push({
            value: dataItem.teachId,
            label: `${dataItem.lastname} ${dataItem.firstname} ${dataItem.patr}`
        })
    })
    setTeachers(dataArr)
  })

  useEffect(() => {
    getDisciplineAndTeacherByStudentId(studentId)
    getTeachers()
  }, [])

  const getQuestionTextById = (qId) => {
    return questions.find(q => q.id == qId)?.text
  }

  const updateDisciplineAndTeacher = (disciplineId, newTeacherId, newTeacherFio) => {
    const discAndTeachIndex = disciplineAndTeacher.findIndex(el => el.id == disciplineId)
    const newDiscAndTeacher = [...disciplineAndTeacher]
    newDiscAndTeacher[discAndTeachIndex] = {
      ...disciplineAndTeacher[discAndTeachIndex],
      teachers: {
        id: newTeacherId,
        fio: newTeacherFio
      }
    }
    setDisciplineAndTeacher(newDiscAndTeacher)
  }
  const getTeacherByDisciplineId = (disciplineId) => {
    const teacher = disciplineAndTeacher.find(el => el.id == disciplineId)?.teachers
    return {
      value: teacher.id,
      label: teacher.fio
    }
  }

  return (
    <div className='question'>
        <div className="container">
            <h2 className="question__title title">
                {
                  qNumber + ". " + getQuestionTextById(qId)
                }
            </h2>
            <div className="question__table">
                    {
                      (isDisciplineAndTeacherLoading && isTeachersLoading)
                      ? <Loader />
                      :
                        <table>
                          <thead>
                            <tr>
                              <th>Дисциплина</th>
                              <th>Преподаватель</th>
                            </tr>
                          </thead>
                          <tbody>
                          {
                            disciplineAndTeacher.map(item => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.name}</td>
                                  <td>
                                      <Select
                                        onChange={(newValue) => { updateDisciplineAndTeacher(item.id, newValue.value, newValue.label); }}
                                        options={teachers}
                                        value={getTeacherByDisciplineId(item.id)}
                                        isDisabled={false}
                                      />
                                  </td>
                                </tr>
                              )
                            })
                          }
                          </tbody>
                        </table>
                    }
                
            </div>
            <Link to={`/student/question/${parseInt(qNumber) + 1}`} state={ { questions: questions, disciplineAndTeacher: disciplineAndTeacher } } className="question__next-btn btn">Далее</Link>
        </div>
    </div>
  )
}

export default QuestionTeacher